var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIonLogoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 781,
    height: 914,
    viewBox: "0 0 781 914",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M311.798 232.705C282.155 232.742 258.15 256.784 258.15 286.428V331.256L536.318 330.845C536.318 297.452 536.318 266.68 536.318 232.294L311.798 232.705Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.561 632.875C258.598 662.526 282.633 682.864 312.268 682.864H356.814L356.403 424.063C323.02 424.063 292.527 424.063 258.15 424.063L258.561 632.875Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M727.358 282.447C727.321 252.796 703.286 232.458 673.651 232.458H629.105L629.516 491.573C662.899 491.573 693.393 491.573 727.769 491.573L727.358 282.447Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M727.575 584.38H449.594C449.594 616.578 449.594 651.719 449.594 682.871H674.114C703.757 682.834 727.762 658.792 727.762 629.148L727.575 584.38Z",
    fill: "white",
    fillOpacity: 0.06
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M614.643 0H368.357C122.378 0 0 149.585 0 457.553C0 765.521 122.378 914 368.357 914H614.643C860.503 914 983 765.274 983 457.553C983 149.831 860.503 0 614.643 0ZM596.208 817.72C485.202 817.72 596.208 818.153 596.208 818.153H386.12C386.12 818.153 497.126 817.72 386.12 817.72C121.825 817.72 122.378 660.203 122.378 457.799C122.378 255.395 121.579 97.0195 386.12 97.0195H596.208C860.503 97.0195 859.95 255.395 859.95 457.799C859.95 660.203 860.503 817.473 596.208 817.473V817.72Z",
    fill: "white",
    fillOpacity: 0.06
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonLogoBackground);
export default __webpack_public_path__ + "static/media/ion-logo-background.b1cb28132cf6a0014c7ce27e93df6b49.svg";
export { ForwardRef as ReactComponent };